import React, { useContext } from 'react';
import SHDButton from '@ui/Button/SHDButton';
import SHDFooter from '@ui/Footer/SHDFooter';
import SHDHeading from '@ui/Heading/SHDHeading';
import SHDText from '@ui/Text/SHDText';
import SHDModalContainer from '@ui/ModalContainer/SHDModalContainer';
import { Box } from 'grommet';
import { IntroPageProps } from '../Onboarding.d';
import { ResponsiveContext } from 'grommet';
import { FormClose } from 'grommet-icons';

const StreamIntroPage: React.FC<IntroPageProps> = ({
  modalHeight,
  onContinue,
  onClose,
}) => {
  const screen = useContext(ResponsiveContext);

  return (
    <Box direction="column" height={modalHeight} margin={{ top: '-45px' }}>
      <Box
        background="shd-yellow"
        alignSelf="center"
        style={{ position: 'relative', width: '100%' }}
      >
        <Box
          direction="row"
          onClick={() => onClose()}
          justify="end"
          style={{ position: 'absolute', right: '0', top: '0' }}
        >
          <Box pad={{ right: 'medium', top: 'medium' }}>
            <FormClose size="30px" color="black" />
          </Box>
        </Box>

        {screen === 'large' || screen === 'xlarge' ? (
          <img
            src="/onboarding/introPageLiveStream.png"
            alt="Live Stream Preview"
            width={500}
            style={{ margin: '0 auto' }}
          />
        ) : (
          <img
            src="/onboarding/introPageLiveStream.png"
            alt="Live Stream Preview"
          />
        )}
      </Box>

      <SHDModalContainer>
        <Box gap="xlarge" pad={{ vertical: 'small' }}>
          <SHDHeading level="3" textAlign="center">
            Let&apos;s get ready for your first live stream
          </SHDHeading>

          <SHDText color="gray-900-alpha-80" style="subhead" textAlign="center">
            Bring the next game to your friends and family&apos;s living room.
          </SHDText>
        </Box>
      </SHDModalContainer>

      <SHDFooter>
        <Box
          style={{
            position: 'relative',
            transform:
              screen === 'large' || screen === 'xlarge'
                ? 'translateY(0px)'
                : 'translateY(36px)',
          }}
        >
          <SHDModalContainer>
            <SHDButton primary label="Get started" onClick={onContinue} />
          </SHDModalContainer>
        </Box>
      </SHDFooter>
    </Box>
  );
};

export default StreamIntroPage;
